import { render, staticRenderFns } from "./SessionDetailModal.vue?vue&type=template&id=0d5c2291&scoped=true&"
import script from "./SessionDetailModal.vue?vue&type=script&lang=js&"
export * from "./SessionDetailModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d5c2291",
  null
  
)

export default component.exports